import { useAuth } from '../../auth/index.js';
import styles from './SettingsTab.module.css';

/**
 * Settings tab in the post-auth hub. For now: account details only.
 * Future cross-classroom defaults (theme, kiosk preferences, etc.)
 * land here per docs/CLASSROOM_HUB_PLAN.md.
 *
 * The hub header already exposes a Logout pill, so this tab does NOT
 * duplicate a sign-out button.
 */
export function SettingsTab() {
  const auth = useAuth();
  const account = auth.account;
  return (
    <div className={styles.tab}>
      <section
        className={`glass glass--solid ${styles.section}`}
        aria-labelledby="settings-account"
      >
        <h2 id="settings-account" className={styles.heading}>
          Account
        </h2>
        <dl className={styles.list}>
          <div className={styles.row}>
            <dt>Name</dt>
            <dd>{account?.name ?? '—'}</dd>
          </div>
          <div className={styles.row}>
            <dt>Email</dt>
            <dd>{account?.email ?? '—'}</dd>
          </div>
          <div className={styles.row}>
            <dt>Sign-in</dt>
            <dd>Microsoft Entra ID</dd>
          </div>
        </dl>
      </section>

      <section
        className={`glass glass--solid ${styles.section}`}
        aria-labelledby="settings-defaults"
      >
        <h2 id="settings-defaults" className={styles.heading}>
          Defaults
        </h2>
        <p className={styles.placeholder}>
          Cross-classroom defaults (theme, page templates, kiosk behavior) land here as we add them.
          Today, theme + page selection is per-classroom — open a classroom and use its tabs to
          configure.
        </p>
      </section>
    </div>
  );
}
